import { useSelector } from "react-redux";
import { ApplicationState } from "../rootStore";

export const usePartTypeReducer = () => useSelector((state: ApplicationState) => state.partType);
